import { render, staticRenderFns } from "./editGruppiMailDettagliEditMail.vue?vue&type=template&id=1da25f03&"
import script from "./editGruppiMailDettagliEditMail.vue?vue&type=script&lang=js&"
export * from "./editGruppiMailDettagliEditMail.vue?vue&type=script&lang=js&"
import style0 from "./editGruppiMailDettagliEditMail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VForm,VRow,VTextField})
